import * as Yup from 'yup';

export class ScheduledValidator {
    private static ValidationSchema: Yup.AnySchema = Yup.object().shape({
        dealershipId: Yup.number()
            .typeError("Must be a number")
            .required("Required field")
            .moreThan(0, "You need to select a dealership"),
        reorderPeriod: Yup.number()
            .typeError("Please select a valid period")
            .required("Reorder period is required")
            .moreThan(0, "Please select a valid period from the list"),
        productId: Yup.number()
            .typeError("Must be a number")
            .required("Product is required")
            .moreThan(0, "You need to select a product"),
        quantity: Yup.number()
            .typeError("Must be a number")
            .required("Quantity is required")
            .moreThan(0, "Quantity must be greater than 0"),
    });
    public static GetSchema(): Yup.AnySchema {
        return this.ValidationSchema
    }
}